import React, { useState, useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { loadAbsences, deleteAbsence } from "./employeeAbsencesSlice";
import { listEmployeeScheduling } from "../../api/server";
import { useQuery } from "react-query";
import moment from "moment";
import { Modal, Table, Typography, Button, Tooltip } from "antd";
import Surface from "../../components/layouts/Surface";
import AddUpdateAbsence from "./components/AddUpdateAbsence";
import Date from "../../components/tables/Date";
import AbsenceReason from "../../components/tables/AbsenceReason";
import FormHeaderWrapper from "../../components/forms/FormHeader.style";
import {
  EditOutlined,
  DeleteOutlined,
  ExclamationCircleOutlined,
  CalendarOutlined,
} from "@ant-design/icons";
import { createAbsence, updateAbsence } from "./employeeAbsencesSlice";
import SchedulingModal from "./components/SchedulingModal";
import ReplacementsModal from "../employees/replacements/ReplacementsModal";
import { useParams } from "react-router-dom";

const { Title } = Typography;

const Absences = () => {
  const dispatch = useDispatch();
  const [modal, contextHolder] = Modal.useModal();
  let { branchId } = useParams();
  const [visible, setVisible] = useState(false);
  const [replacementsVisible, setReplacementsVisible] = useState(false);
  const [addUpdateAbsenceVisible, setAddUpdateAbsenceVisible] = useState(false);
  const [mode, setMode] = useState(null);
  const [activeRecord, setActiveRecord] = useState(null);
  const [absenceValues, setAbsenceValues] = useState({});
  const [timeFrameValues, setTimeFrameValues] = useState({});
  const [conflictingSchedulingVisible, setConflictingSchedulingVisible] =
    useState(false);
  const [hasApprovedScheduling, setHasApprovedScheduling] = useState(false);
  const [triggerQueryTimestamp, setTriggerQueryTimestamp] = useState(null);

  const items = useSelector((state) => state.employeeAbsences.absences);
  const activeEmployee = useSelector(
    (state) => state.employeeDetails.activeEmployee
  );
  const scopePrefix = useSelector((state) => state.user.scopePrefix);

  const loading = useSelector(
    (state) => state.pendingActions["employeeAbsences/load"]
  );
  const deleteLoading = useSelector(
    (state) => state.pendingActions["employeeAbsences/delete"]
  );

  const deleteScedulingLoading = useSelector(
    (state) => state.pendingActions["scheduling/delete"]
  );

  const createLoading = useSelector(
    (state) => state.pendingActions["employeeAbsences/create"]
  );

  const intl = useIntl();

  const employeeBranchId = branchId
    ? branchId
    : activeEmployee && activeEmployee.branch_active[0]
    ? activeEmployee.branch_active[0].branch_id
    : null;

  useEffect(() => {
    dispatch(loadAbsences(activeEmployee.id));
  }, [dispatch, activeEmployee.id]);

  const onEdit = (record) => {
    setActiveRecord(record);
    setMode("edit");
    setAddUpdateAbsenceVisible(true);
    setVisible(true);
  };

  const onAdd = (record) => {
    setMode("new");
    setAddUpdateAbsenceVisible(true);
    setVisible(true);
  };

  const onDelete = async (record) => {
    setActiveRecord(record);
    const params = {
      branchId: employeeBranchId,
      employeeId: activeEmployee.id,
      absenceId: record.id,
    };
    const action = await dispatch(deleteAbsence(params));
    if (!action.error) {
      setActiveRecord(null);
      dispatch(loadAbsences(activeEmployee.id));
    }
  };

  const onShowReplacements = (record) => {
    const { effective_from, effective_to } = record;
    setTimeFrameValues({
      effective_from,
      effective_to,
    });
    setReplacementsVisible(true);
  };

  const onHideReplacements = (record) => {
    setReplacementsVisible(false);
  };
  const hide = () => {
    setVisible(false);
    setConflictingSchedulingVisible(false);
    dispatch(loadAbsences(activeEmployee.id));
    setAddUpdateAbsenceVisible(false);
    setActiveRecord(null);
  };

  const setValues = (values) => {
    const { effective_from, effective_to, reason_id, comment } = values;
    setAbsenceValues({
      effective_from: moment(effective_from).startOf("day").format(),
      effective_to: moment(effective_to).endOf("day").format(),
      reason_id,
      comment,
    });
  };

  const onSubmit = async () => {
    const scheduling = await getConflictingScheduling(absenceValues);
    if (scheduling.length > 0) {
      setConflictingSchedulingVisible(true);
      setVisible(false);
    } else {
      commitAbsences(false);
    }
  };

  const { isLoading, data } = useQuery(
    [scopePrefix, activeEmployee, absenceValues, triggerQueryTimestamp],
    async () => {
      const employeeId = activeEmployee.id;
      const branchId = employeeBranchId;
      const startDate = moment(absenceValues.effective_from).startOf("day");
      var endDate = moment(absenceValues.effective_to).endOf("day");
      const newState = {
        current: 1,
        pageSize: 100,
        filter: {
          date: {
            $gt: startDate.format(),
            $lt: endDate.format(),
          },
        },
      };
      const listParams = { ...newState, scopePrefix, employeeId, branchId };
      const scheduling = await listEmployeeScheduling(listParams);
      let items = [];
      let hasAprroval = false;
      if (
        scheduling &&
        scheduling.data &&
        scheduling.data.items &&
        scheduling.data.items.length > 0
      ) {
        scheduling.data.items.forEach((item, i) => {
          let temp = { ...item };
          if (item.approved) {
            hasAprroval = true;
          }
          if (
            scheduling.data.effective_orders &&
            scheduling.data.effective_orders.length > 0
          ) {
            const order = scheduling.data.effective_orders.filter(
              (i) => i.id === item.order_id
            )[0];
            temp["order"] = order;
          }
          items.push(temp);
        });
      }
      setHasApprovedScheduling(hasAprroval);
      return items;
    },
    {
      staleTime: 0,
      enabled:
        absenceValues.effective_from !== undefined &&
        absenceValues.effective_to !== undefined,
    }
  );

  const getConflictingScheduling = async (values) => {
    const employeeId = activeEmployee.id;
    const branchId = employeeBranchId;
    const startDate = moment(values.effective_from).startOf("day");
    var endDate = moment(values.effective_to).endOf("day");
    const newState = {
      current: 1,
      pageSize: 100,
      filter: {
        date: {
          $gt: startDate.format(),
          $lt: endDate.format(),
        },
      },
    };
    const listParams = { ...newState, scopePrefix, employeeId, branchId };
    const scheduling = await listEmployeeScheduling(listParams);
    let items = [];
    let hasAprroval = false;
    if (
      scheduling &&
      scheduling.data &&
      scheduling.data.items &&
      scheduling.data.items.length > 0
    ) {
      scheduling.data.items.forEach((item, i) => {
        let temp = { ...item };
        if (item.approved) {
          hasAprroval = true;
        }
        if (
          scheduling.data.effective_orders &&
          scheduling.data.effective_orders.length > 0
        ) {
          const order = scheduling.data.effective_orders.filter(
            (i) => i.id === item.order_id
          )[0];
          temp["order"] = order;
        }
        items.push(temp);
      });
    }
    setHasApprovedScheduling(hasAprroval);
    return items;
  };
  const commitAbsences = async (delete_events) => {
    const params = {
      absence: { ...absenceValues, delete_events },
      branchId: employeeBranchId,
      employeeId: activeEmployee.id,
      absenceId: mode === "edit" && activeRecord ? activeRecord.id : null,
    };
    const action =
      mode === "edit"
        ? await dispatch(updateAbsence(params))
        : await dispatch(createAbsence(params));
    if (!action.error) {
      hide();
    }
  };

  const onSubmitForceAbsences = () => {
    const title = intl.formatMessage({
      id: `app.absences.forceTitle`,
    });
    const content = intl.formatMessage({
      id: "app.absences.forceContent",
    });
    modal.confirm({
      title: title,
      icon: <ExclamationCircleOutlined />,
      content: content,
      onOk() {
        return commitAbsences(true);
      },
    });
  };

  const triggerFetch = (timestamp) => {
    setTriggerQueryTimestamp(timestamp);
  };

  return (
    <Surface>
      {contextHolder}
      <FormHeaderWrapper>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <Title level={5} style={{ margin: 0 }}>
            <FormattedMessage id={`app.absences.title`} />
          </Title>
          <Button type="primary" onClick={onAdd}>
            <FormattedMessage id={`app.absences.addAbsence`} />
          </Button>
        </div>
      </FormHeaderWrapper>

      <Table
        bordered
        rowKey={(record) => record.id}
        scroll={{ y: window.innerHeight - 526 }}
        dataSource={items}
        pagination={false}
        columns={[
          {
            title: intl.formatMessage({
              id: "app.absences.effective_from",
            }),
            dataIndex: "effective_from",
            sortIndex: "effective_from",
            width: "120px",
            type: "date",
            required: true,
            render(text, record) {
              return <Date text={text} format={"L"} />;
            },
            sorter: (a, b) =>
              a["effective_from"].localeCompare(b["effective_from"]),
            sortDirections: ["descend", "ascend"],
            defaultSortOrder: "descend",
          },
          {
            title: intl.formatMessage({
              id: "app.absences.effective_to",
            }),
            dataIndex: "effective_to",
            sortIndex: "effective_to",
            sorter: true,
            width: "120px",
            type: "date",
            required: true,
            render(text, record) {
              return <Date text={text} format={"L"} />;
            },
          },
          {
            title: intl.formatMessage({
              id: "app.absences.reason_id",
            }),
            dataIndex: "reason_id",
            type: "settingsDataItem",
            render(text, record) {
              return (
                <AbsenceReason
                  record={record}
                  text={text}
                  settingsataName={"system_tables/absence_reasons"}
                />
              );
            },
          },
          {
            title: intl.formatMessage({
              id: "app.absences.comment",
            }),
            dataIndex: "comment",
            ellipsis: true,
          },

          {
            title: intl.formatMessage({
              id: "app.absences.actions",
            }),
            width: "130px",
            render(text, record) {
              return (
                <div style={{ display: "flex" }}>
                  <Tooltip
                    title={<FormattedMessage id="app.absences.delete" />}
                  >
                    <Button
                      type="text"
                      loading={deleteLoading && activeRecord.id === record.id}
                      onClick={() => {
                        onDelete(record);
                      }}
                      icon={<DeleteOutlined style={{ color: "red" }} />}
                    />
                  </Tooltip>
                  <Tooltip title={<FormattedMessage id="app.absences.edit" />}>
                    <Button
                      type="text"
                      onClick={() => {
                        onEdit(record);
                      }}
                      icon={<EditOutlined />}
                    />
                  </Tooltip>
                  <Tooltip
                    title={<FormattedMessage id="app.absences.showGhosts" />}
                  >
                    <Button
                      type="text"
                      onClick={() => {
                        onShowReplacements(record);
                      }}
                      icon={<CalendarOutlined />}
                    />
                  </Tooltip>
                </div>
              );
            },
          },
        ]}
        loading={loading}
      />
      <Modal
        closable={false}
        maskClosable={false}
        open={visible}
        footer={null}
        onCancel={hide}
        title={null}
        width={"fit-content"}
        styles={{
          body: {
            padding: 0,
          },
        }}
        destroyOnClose={true}
      >
        {addUpdateAbsenceVisible ? (
          <AddUpdateAbsence
            hide={hide}
            mode={mode}
            record={activeRecord}
            setValues={setValues}
            onSubmit={onSubmit}
            addText={
              mode === "edit" ? (
                <FormattedMessage id="app.absences.editAbsence" />
              ) : (
                <FormattedMessage id="app.absences.addNewAbsence" />
              )
            }
          />
        ) : null}
      </Modal>
      <ReplacementsModal
        visible={replacementsVisible}
        onHide={onHideReplacements}
        triggerFetch={triggerFetch}
        triggerQueryTimestamp={triggerQueryTimestamp}
        timeFrameValues={timeFrameValues}
        title={<FormattedMessage id={`app.scheduling.replacementsTitle`} />}
        subTitle={
          <FormattedMessage id={`app.scheduling.replacementsSubTitle`} />
        }
      />
      <SchedulingModal
        onCancel={hide}
        onSubmitForceAbsences={onSubmitForceAbsences}
        onCommit={commitAbsences}
        visible={conflictingSchedulingVisible}
        data={data}
        hasApprovedScheduling={hasApprovedScheduling}
        absenceValues={absenceValues}
        triggerFetch={triggerFetch}
        triggerQueryTimestamp={triggerQueryTimestamp}
        isLoading={isLoading}
        createLoading={createLoading}
        activeEmployee={activeEmployee}
      />
    </Surface>
  );
};
export default Absences;
